/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import { useLayoutEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LogoIcon1 from "../../../assets/images/logoIcon.svg";
import { useSelector } from "react-redux";

const LeftMenu = () => {
  const [screenSize, setScreenSize] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const navSidebarIsShow = useSelector(
    (state) => state.reference.navSidebarIsShow
  );

  /**
   * Detect the size
   */
  function updateSize() {
    setScreenSize(window.innerWidth);
  }

  /**
   * Get the menu toggle class
   */
  const getMenuToggleClass = (inputSize) => {
    if (inputSize <= 767 && !navSidebarIsShow) {
      return "toggled";
    }

    return "";
  };

  useLayoutEffect(() => {
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return (
    <>
      <ul
        className={`navbar-nav bg-gradient-primary sidebar sidebar-dark accordion ${getMenuToggleClass(screenSize)}`}
        id="accordionSidebar"
      >
        <a
          className={`sidebar-brand d-flex align-items-center justify-content-center`}
          href="#"
          onClick={(event) => {
            event.preventDefault();
            navigate("/adminDashboard");
          }}
        >
          <div className="sidebar-brand-icon">
            <img src={LogoIcon1} alt="Cubet" />
          </div>
          <div className="sidebar-brand-text mx-3">Connections</div>
        </a>

        <hr className="sidebar-divider my-0" />

        <li
          className={`nav-item  ${location?.pathname === "/adminDashboard" ? "active" : ""}`}
        >
          <a
            className="nav-link"
            href="index.html"
            onClick={(event) => {
              event.preventDefault();
              navigate("/adminDashboard");
            }}
          >
            <i className="fas fa-fw fa-tachometer-alt"></i>
            <span>Dashboard</span>
          </a>
        </li>

        <hr className="sidebar-divider my-0" />

        <li
          className={`nav-item ${["/adminReference", "/adminEditReference", "/adminViewReference"].includes(location?.pathname) ? "active" : ""}`}
        >
          <a
            className="nav-link"
            href="referrals.html"
            onClick={(event) => {
              event.preventDefault();
              navigate("/adminReference");
            }}
          >
            <i className="fas fa-fw fa-file-invoice-dollar"></i>
            <span>Referrals</span>
          </a>
        </li>

        <hr className="sidebar-divider my-0" />

        <li
          className={`nav-item ${location?.pathname === "/adminCustomer" ? "active" : ""}`}
        >
          <a
            className="nav-link"
            href="index.html"
            onClick={(event) => {
              event.preventDefault();
              navigate("/adminCustomer");
            }}
          >
            <i className="fas fa-fw fa-users"></i>
            <span>Referral Partners</span>
          </a>
        </li>

        <hr className="sidebar-divider" />
      </ul>
    </>
  );
};

export default LeftMenu;
